import apiClient from "./client";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";

export async function getWarps({ search, type, page = 1, limit } = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (type) params.set("type", type);
  params.set("page", String(page));
  if (limit) params.set("limit", String(limit));
  return apiClient.get(`/warps?${params.toString()}`);
}

export async function getWarp(id) {
  return apiClient.get(`/warps/${id}`);
}

export async function getMyWarps() {
  return apiClient.get("/warps/my");
}

export async function getPendingWarps() {
  return apiClient.get("/warps/pending");
}

export async function getAdminWarps() {
  return apiClient.get("/warps/admin/all");
}

export async function createWarp(data) {
  return apiClient.post("/warps", data);
}

export async function updateWarp(id, data) {
  return apiClient.put(`/warps/${id}`, data);
}

export async function deleteWarp(id) {
  return apiClient.delete(`/warps/${id}`);
}

export async function publishWarp(id, isPublished) {
  return apiClient.patch(`/warps/${id}/publish`, { isPublished });
}

export async function uploadWarpImage(warpId, file) {
  const formData = new FormData();
  formData.append("image", file);

  const headers = {};
  if (apiClient.accessToken) {
    headers["Authorization"] = `Bearer ${apiClient.accessToken}`;
  }

  const response = await fetch(`${API_BASE}/warps/${warpId}/images`, {
    method: "POST",
    headers,
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Upload failed");
  }
  return data;
}

export async function deleteWarpImage(warpId, imageId) {
  return apiClient.delete(`/warps/${warpId}/images/${imageId}`);
}

export async function uploadWarpDescriptionImage(file) {
  const formData = new FormData();
  formData.append("image", file);
  const headers = {};
  if (apiClient.accessToken) {
    headers.Authorization = `Bearer ${apiClient.accessToken}`;
  }
  const response = await fetch(`${API_BASE}/warps/upload-description-image`, {
    method: "POST",
    headers,
    body: formData,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Image upload failed");
  }
  return data;
}
